export const PRIMER_OVERLAY_ZINDEX = 1000;
export const PRIMER_DIALOG_ZINDEX = 999; // fixed by primer
